module.exports = __webpack_public_path__ + "img/5.45d213a8.jpg";